'use strict';

app.controller('plotgraphcontroller', ['$scope', '$location', 'plotgraphservice', 'plotDataService', 'progressBarService', '$rootScope', '$cookies', '$window', '$timeout', '$routeParams', 'deviceDetector', '$http', function ($scope, $location, plotgraphservice, plotDataService, progressBarService, $rootScope, $cookies, $window, $timeout, $routeParams, deviceDetector, $http) {

    if ($routeParams.workspacedid != undefined && $routeParams.workspacedid != null) {
        $rootScope.urlworkspaceid = $routeParams.workspacedid;
    }

    if ($cookies.get('TokenInfo') == undefined || localStorage.getItem('appInfo') == undefined) {
        $location.path('/login');
        return false;
    }

    $scope.isKratosData = getLocalValue("isKratosData");

    //if ($cookies.get('UserId') != null && $cookies.get('UserId') != 'undefined' && $cookies.get('UserId') != '') {
    //    $scope.UserId = $cookies.get('UserId');
    //}

    $scope.serviceBase = $rootScope.buildConfig.aippsssApiBaseUrl;

    plotDataService.clearDeletedSearchString();
    plotDataService.clearDeletedObjectIDList();
    progressBarService.showProgressBar();
    //$scope.premiumType = parseInt($cookies.get("premiumType") == undefined ? 2 : $cookies.get("premiumType"));
    if ($rootScope.urlworkspaceid != undefined && $rootScope.urlworkspaceid != null && $rootScope.urlworkspaceid != "") {
        plotDataService.clearSpectrumIds();
        plotDataService.clearObjectIds();
        plotDataService.clearTechnique();
        plotDataService.clearDataSetDisplayString();
        plotDataService.clearSearchString();
        plotDataService.clearFiles();
        $rootScope.SelectedWorkArea = null;
        //if ($scope.SessionUploadID != '') {
        //    plotgraphservice.deleteUnpublishedDataSets($scope, '', '', true);
        //}
        plotgraphservice.GetWorkSpaceDetailsById($scope, $rootScope.urlworkspaceid, true);
        $rootScope.fromworkspaceurl = true;
    } else if ($rootScope.compareStoreData != undefined && $rootScope.compareStoreData.length > 0) {
        plotDataService.clearSpectrumIds();
        plotDataService.clearObjectIds();
        plotDataService.clearTechnique();
        plotDataService.clearDataSetDisplayString();
        plotDataService.clearSearchString();
        plotDataService.clearFiles();
        $rootScope.SelectedWorkArea = null;
        //if ($scope.SessionUploadID != '') {
        //    plotgraphservice.deleteUnpublishedDataSets($scope, '', '', true);
        //}

        plotgraphservice.GetComparingObjectsData($scope, $rootScope.compareStoreData);
        $rootScope.compareStoreData = undefined;
    }

    $scope.objectIdList = plotDataService.getObjectIds();
    $scope.spectrumIdList = plotDataService.getSpectrumIds();
    $scope.startendValues = plotDataService.getStartEndValues();
    $scope.fileDataSet = plotDataService.getFiles();
    $scope.dataSetList = plotDataService.getSetdata();

    $scope.checkPremiumType = function (spectrumId) {

        var isValid = true;
        $.each($scope.dataSetList, function (index, key) {
            if (key.IsCurated != undefined && key.IsCurated == true && key.SpectrumId == spectrumId && key.SpectrumId != 0 && $scope.premiumType == 0) {
                isValid = false;

                return isValid;
            }
        })
        return isValid
    }

    $scope.isDownloadNotRistricted = true;
    $scope.searchResults = [];
    $scope.searchResultsBackUp = [];
    $scope.searchResultMsg = "";
    var chart;
    function setMobileSize(value) {
        if (value < 768) {
            $scope.mobileSize = true;
        } else {
            $scope.mobileSize = false;
        }
    };

    setMobileSize($window.innerWidth);
    $scope.SessionUploadID = $cookies.get('SessionID');

    $rootScope.SearchLinkCSS = '';
    $rootScope.PlotGraphLinkCSS = 'active';
    $rootScope.SaveWorkspaceLinkCSS = '';

    var vm = this;
    vm.data = deviceDetector;
    vm.allData = JSON.stringify(vm.data, null, 2);
    $scope.device = vm.data.device;

    // Set Technique    
    $scope.SetTechnique = function () {
        $scope.technique = plotDataService.getTechnique();

        if ($scope.technique != null && $scope.technique.length > 0) {
            var flagXPSUPS = false;
            var flagAES = false;
            var flagUnspec = false;
            $scope.flagUV = false;

            for (var i = 0; i < $scope.technique.length; i++) {
                var temp = $scope.technique[i].split("-");
                if (temp[1] == "XPS" || temp[1] == "UPS") {
                    flagXPSUPS = true;
                }
                else if (temp[1] == "AES") {
                    flagAES = true;
                } else if (temp[1] == "UV") {
                    $scope.flagUV = true;
                } else if (temp[1] == "Unspecified") {
                    flagUnspec = true;
                }
            }
            if (flagXPSUPS) {
                CheckTechnique("xps")
            } else {
                UnCheckTechnique("xps");
            }

            if (flagAES) {
                CheckTechnique("aes");
            } else {
                UnCheckTechnique("aes");
            }

            if (flagUnspec) {
                CheckTechnique("unspecified");
            } else {
                UnCheckTechnique("unspecified");
            }

            if ($scope.flagUV) {
                CheckTechnique("uv-vis")
            } else {
                UnCheckTechnique("uv-vis");
            }
        }
    }

    function CheckTechnique(techName) {
        $(".graph-figures input[type=radio]").each(function () {
            var _this = $(this);
            if (_this.attr("graph-figures").toLowerCase() == techName.toLowerCase()) {
                _this.prop("checked", true);
            }
        });
    }

    function UnCheckTechnique(techName) {
        $(".graph-figures input[type=radio]").each(function () {
            var _this = $(this);
            if (_this.attr("graph-figures").toLowerCase() == techName.toLowerCase()) {
                _this.prop("checked", false);
                _this.prop("disabled", true);
                _this.parent().addClass("disabled");
            }
        });
    }

    $scope.SetTechnique();

    if ($scope.objectIdList.length > 0 || $scope.spectrumIdList.length > 0 || $scope.fileDataSet.length > 0 || plotDataService.getUnPublishedDataSet().length > 0 || $scope.fileDataSet.length > 0) {
        plotgraphservice.renderChart2($scope, $location, "chartdiv", "legendDivId", true);
    }
    else {
        // No spectrum Id found
        progressBarService.hideProgressBar();
        var paramValue = $location.search().workspacedid;
        if (paramValue != null || paramValue != undefined) {
            $location.search('workspacedid', null);
        }
        $location.path('/search');
    }

    $scope.ShowGraphByGraphFigures = function (graphFiguresValue) {
        $timeout(function () {
            progressBarService.showProgressBar();

            $timeout(function () {
                plotgraphservice.renderChart2($scope, $location, "chartdiv", "legendDivId", false);
            }, 50);
        }, 50);
    }

    $scope.ShowPlottedResult = function (technique, obj) {
        $(".graph-figures input[type=radio]").each(function () {
            if ($(this).prop("checked") == true) {
                getFigure = $(this).attr("graph-figures");
            }
        })
        if (technique.toLowerCase() == getFigure.toLowerCase() || (technique.toLowerCase() == "ups" && getFigure.toLowerCase() == "xps") || technique.toLowerCase() == "unpublished") {
            return false;
        }
        else {
            return true;
        }
    }

    $scope.SetYOffTextBox = function (technique, spectrumID, offsetApplied, visible) {

        $(".graph-figures input[type=radio]").each(function () {
            if ($(this).prop("checked") == true) {
                getFigure = $(this).attr("graph-figures");
            }
        })

        if ((technique.toLowerCase() == getFigure.toLowerCase() || (technique == "UPS" && getFigure == "XPS") || technique == "UnPublished") && visible == true) {

            if (offsetApplied) {
                /// Disable
                $("#plotDetails .offset-input[spectrum-id='" + spectrumID + "']").attr("disabled", "disabled");
            }
            else {
                /// Enable
                $("#plotDetails .offset-input[spectrum-id='" + spectrumID + "']").attr("disabled", "");
                $("#plotDetails .offset-input[spectrum-id='" + spectrumID + "']").removeAttr("disabled");
            }

            return false;
        }
        else {
            return true;
        }
    }

    $scope.RemoveGraph = function (spectrumID, technique, objectStatusType, obj) {

        $timeout(function () {
            progressBarService.showProgressBar();

            $timeout(function () {
                progressBarService.showProgressBar();

                var index;
                for (var count = 0; count < $scope.searchResults.length; count++) {
                    if ($scope.searchResults[count].displayID == spectrumID) {
                        index = count;
                        break;
                    }
                }

                // remove techniques
                plotDataService.setTechnique(spectrumID, technique, false);

                // remove
                $scope.searchResults.splice(index, 1);
                progressBarService.showProgressBar();
                // remove other related data
                $scope.searchStringList = plotDataService.getSearchString();

                if ($rootScope.SelectedWorkArea != undefined && $rootScope.SelectedWorkArea != null && $rootScope.SelectedWorkArea.name.length > 0  && objectStatusType.toLowerCase() == 'active') {

                    angular.forEach($scope.searchStringList, function (value, key) {
                        if (value.FileName == spectrumID || value.ObjectId == spectrumID) {
                            plotDataService.addDeletedSearchString(value);
                        }
                    });

                    plotDataService.setDeletedObjectIDList(spectrumID);
                }

                plotDataService.removeSpectrumIds(parseInt(spectrumID));
                plotDataService.removeFiles(parseInt(spectrumID));
                plotDataService.removeObjectIds(parseInt(spectrumID));
                plotDataService.removeDataSetDisplayString(spectrumID);
                plotDataService.removeSearchString(spectrumID);


                var techniqueFound = false;

                if (technique == "UnPublished") {
                    techniqueFound = true;
                }
                else {
                    for (var count = 0; count < $scope.searchResults.length; count++) {
                        if ($scope.searchResults[count].technique == technique) {
                            techniqueFound = true;
                            break;
                        }
                    }
                }

                if (techniqueFound == false) {
                    $scope.SetTechnique();
                }

                //disable save button
                $scope.SetWorkSpaceSaveBuuton();

                plotgraphservice.renderChart2($scope, $location, "chartdiv", "legendDivId", false);
            }, 5);
        }, 5);


    }

    $scope.VisibleGraph = function (spectrumID, obj) {
        var element = document.getElementById("checkbox-" + spectrumID);
        $(element).toggleClass("fa-check");
        progressBarService.showProgressBar();
        $timeout(function () {
            $timeout(function () {
                for (var count = 0; count < $scope.searchResults.length; count++) {
                    if ($scope.searchResults[count].displayID == spectrumID) {
                        //if (obj.target.checked == true) {
                        if ($(element).hasClass("fa-check")) {
                            $scope.searchResults[count].visible = true;
                        }
                        else {
                            $scope.searchResults[count].visible = false;
                        }
                        break;
                    }
                }

                plotgraphservice.renderChart2($scope, $location, "chartdiv", "legendDivId", false);
            }, 50);
        }, 5);
    }

    $scope.VisibleSelectedPeakLabel = function (spectrumID, obj) {
        progressBarService.showProgressBar();
        var index;

        return $http({
            method: "GET",
            url: './assets/misc/config.global.json',
            headers: { 'Content-Type': 'application/json' }
        }).success(function (data, status) {
            for (var count = 0; count < $scope.searchResults.length; count++) {
                if ($scope.searchResults[count].displayID == spectrumID) {
                    if (obj.target.className.search("hidden-labels") > 0) {
                        $scope.searchResults[count].showPeakLabel = true;
                    }
                    else {
                        $scope.searchResults[count].showPeakLabel = false;
                    }
                    break;
                }
            }

            plotgraphservice.renderChart2($scope, $location, "chartdiv", "legendDivId", false);
        }).error(function (data, status) {
            console.log("Error - VisibleSelectedPeakLabel");
        });
    }

    $scope.VisibleAllPeakLabel = function (obj) {
        progressBarService.showProgressBar();

        return $http({
            method: "GET",
            //url: $scope.serviceBase + "search",
            url: './assets/misc/config.global.json',
            //params: $scope.pagingInfo,
            headers: { 'Content-Type': 'application/json' }
        }).success(function (data, status) {
            for (var count = 0; count < $scope.searchResults.length; count++) {
                if (obj.target.checked == true) {
                    $scope.searchResults[count].showPeakLabel = true;
                }
                else {
                    $scope.searchResults[count].showPeakLabel = false;
                }
            }

            plotgraphservice.renderChart2($scope, $location, "chartdiv", "legendDivId", false);

        }).error(function (data, status) {
            console.log("Error - VisibleAllPeakLabel");
        });
    }

    $scope.SetYOffsetValue = function (spectrumID, obj) {
        var element = document.getElementById("checkbox-" + spectrumID);
        if ($(element).hasClass("fa-check")) {
            //if ($("#plotDetails .show-hide-graph[spectrum-id='" + spectrumID + "']").prop("checked") == true) {
            if (!isNaN($("#plotDetails .offset-input[spectrum-id='" + spectrumID + "']").val()) && !isNaN(parseFloat($("#plotDetails .offset-input[spectrum-id='" + spectrumID + "']").val()))) {

                progressBarService.showProgressBar();

                var offsetValue = 0;

                if (obj.target.className.search("fa-toggle-on") > 0) {
                    obj.target.className = "fa fa-toggle-off offset-toggle fa-2x mr-0";

                    // Get Value from Original Array
                    for (var count = 0; count < $scope.searchResultsBackUp.length; count++) {
                        if ($scope.searchResultsBackUp[count].displayID == spectrumID) {
                            tempResult = angular.copy($scope.searchResultsBackUp[count]);
                            tempResult.offsetApplied = false;
                            break;
                        }
                    }

                    // set offset value
                    for (var count = 0; count < $scope.searchResults.length; count++) {
                        if ($scope.searchResults[count].displayID == spectrumID) {
                            // Set Peak Status
                            tempResult.showPeakLabel = $scope.searchResults[count].showPeakLabel;
                            $scope.searchResults[count] = tempResult;
                        }
                    }

                    $("#plotDetails .offset-input[spectrum-id='" + spectrumID + "']").val('');

                    // show graph
                    plotgraphservice.renderZoomableChart($scope, $location, "chartdiv", "legendDivId", false);
                }
                else {
                    obj.target.className = "fa fa-toggle-on offset-toggle fa-2x mr-0";
                    // Get Offset Value            
                    offsetValue = $("#plotDetails .offset-input[spectrum-id='" + spectrumID + "']").val();
                    if (offsetValue == "") {
                        offsetValue = 0;
                    }
                    else {
                        offsetValue = parseFloat(offsetValue);
                    }

                    // Show * on legend
                    $("#customLegends").find(".offset-asterisk[spectrum-id='" + spectrumID + "']").css('display', 'inline-block');

                    // Get Value from Original Array
                    var tempResult = [];
                    for (var count = 0; count < $scope.searchResultsBackUp.length; count++) {
                        if ($scope.searchResultsBackUp[count].displayID == spectrumID) {
                            //angular.copy($scope.searchResultsBackUp[count], tempResult);
                            tempResult = angular.copy($scope.searchResultsBackUp[count]);
                            break;
                        }
                    }

                    // set offset value
                    for (var count = 0; count < $scope.searchResults.length; count++) {
                        if ($scope.searchResults[count].displayID == spectrumID) {
                            tempResult.showPeakLabel = $scope.searchResults[count].showPeakLabel;
                            $scope.searchResults[count] = tempResult;
                            var datasetarrayDynamic = [];
                            var peakinfo1 = null;
                            datasetarrayDynamic = $scope.searchResults[count].datapoint.data;
                            peakinfo1 = $scope.searchResults[count].peakInfo;

                            if ($("#plotDetails .offset-input[spectrum-id='" + spectrumID + "']").val() != '') {
                                for (var i = 0; i < datasetarrayDynamic.length; i++) {
                                    datasetarrayDynamic[i][1] = parseFloat(datasetarrayDynamic[i][1]) + offsetValue;
                                }

                                for (var i = 0; i < peakinfo1.length; i++) {
                                    peakinfo1[i].yval = parseFloat(peakinfo1[i].yval) + offsetValue;
                                }
                            }

                            if ($("#plotDetails .offset-input[spectrum-id='" + spectrumID + "']").val() != '') {
                                $scope.searchResults[count].yOffset = offsetValue;
                            }
                            else {
                                $scope.searchResults[count].yOffset = '';
                            }

                            $scope.searchResults[count].offsetApplied = true;
                        }
                    }

                    // show graph
                    plotgraphservice.renderZoomableChart($scope, $location, "chartdiv", "legendDivId", false);

                    //angular.element(document.getElementsByClassName("page-spinner")).hide();
                }
            }
            else {
                $("#plotDetails .offset-input[spectrum-id='" + spectrumID + "']").val('');
            }
        }
    }

    //Redirect to Article
    $scope.redirectToArticle = function (doi) {
        $window.open("http://dx.doi.org/openurl?url_ver=Z39.88-2003&rft_id=doi:" + doi + "&trackingtype=SSS&code=browser", "_blank");
    }

    //Export X, Y Data
    $scope.ExportXYData = function (displayID, spectrumID, fileName, fileExtension) {


        //Filter SpectrumID from searchResultsBackUp
        var spectrumData = [];
        if (spectrumID == 0 && fileName.length > 0) {
            spectrumData = $.grep($scope.searchResultsBackUp, function (element, index) {
                return element.fileName == fileName;
            });

            exportToFile(fileName + "_Download." + fileExtension, spectrumData[0].datapoint.data, fileExtension);
        }
        else {
            spectrumData = $.grep($scope.searchResultsBackUp, function (element, index) {
                return element.displayID == displayID;
            });
            exportToFile(spectrumID + "_Download." + fileExtension, spectrumData[0].datapoint.data, fileExtension);
        }



    }

    function exportToFile(filename, rows, filetype) {

        var processRow = function (row) {
            var finalVal = '';
            for (var j = 0; j < row.length; j++) {
                var innerValue = row[j] === null ? '' : row[j].toString();
                if (row[j] instanceof Date) {
                    innerValue = row[j].toLocaleString();
                };
                var result = innerValue.replace(/"/g, '""');
                if (result.search(/("|,|\r\n)/g) >= 0)
                    result = '"' + result + '"';
                if (j > 0)
                    if (filetype == "csv") {
                        finalVal += ',';
                    }
                    else {
                        finalVal += '\t';
                    }
                finalVal += result;
            }
            return finalVal + '\r\n';
        }


        var csvFile = '';
        for (var i = 0; i < rows.length; i++) {
            csvFile += processRow(rows[i]);
        }

        var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, filename);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", filename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }

    $scope.ShowSpectraFiguredetails = function (displayId, spectrunID, fileName) {
        plotgraphservice.getSpectraFiguredetails($scope, displayId);
    }



    //$scope.closeDetails = function () {
    //    html2canvas($('#chartdiv'), {
    //        onrendered: function (canvas) {
    //            window.scrollTo(0, $scope.scrollY);
    //        }
    //    });
    //};

    $(".navbar-nav").find("li").removeClass("active").removeClass("disabled");
    $(".plotting-area").removeClass("disabled").attr("disabled", false);
    $(".plotting-area").parent().addClass("active");
    $(".plot-chart-xs").hide();

    $scope.$on('ngRepeatBroadcast2', function (ngRepeatFinishedEvent) {
        GenerateImage();
        //Scroll to top of page

        if (!$scope.isPageSecondTimeLoading) {
            $("html, body").animate({
                scrollTop: 0
            }, "500");

            $scope.isPageSecondTimeLoading = true;
        }
        progressBarService.hideProgressBar();
    });

    $scope.SaveWorkspace = function (path) {

        if ($scope.AllowWorkSpaceSave()) {

            var searchStringList = plotDataService.getSearchString();

            angular.forEach($scope.searchResults, function (value, key) {
                if (value.objectStatusType == 'deactivated') {
                    plotDataService.setDeletedObjectIDList(value.displayID);

                    angular.forEach(searchStringList, function (value_0, key_0) {
                        if (value.displayID == value_0.FileName || value.displayID == value_0.ObjectId) {
                            plotDataService.addDeletedSearchString(value_0);
                        }
                    });

                    plotDataService.removeFiles(parseInt(value.displayID));
                    plotDataService.removeObjectIds(parseInt(value.displayID));
                    plotDataService.removeSearchString(value.displayID);
                }
            });
            $location.path(path);
        }
    }

    $scope.CloseWorkSpace = function () {
        $rootScope.SelectedWorkArea = null;
        //plotgraphservice.deleteUnpublishedDataSets($scope, '', '', true);
        plotDataService.clearSpectrumIds();
        plotDataService.clearObjectIds();
        plotDataService.clearTechnique();
        plotDataService.clearFiles();
        plotDataService.clearDataSetDisplayString();
        plotDataService.clearSearchString();
        if ($routeParams.workspacedid != undefined && $routeParams.workspacedid != null) {
            $location.path('/search');
        } else {
            $location.path('/savedWorkedSpace');
        }
    }

    $scope.ShowCitedetails = function (displayID, objectContentType, fileName) {
        if (objectContentType.toLowerCase() != "user" || (objectContentType.toLowerCase() == "user" && fileName == null || fileName == "")) {
            plotgraphservice.getCitedetails($scope, displayID);
        }
        else {
            plotgraphservice.getCitedetailsByFile($scope, displayID);
        }
    }

    $scope.AllowWorkSpaceSave = function () {
        for (var count = 0; count < $scope.searchResults.length; count++) {
            if ($scope.searchResults[count].technique == "UPS" || $scope.searchResults[count].technique == "XPS" || $scope.searchResults[count].technique == "AES" || $scope.searchResults[count].technique == "UV-VIS") {
                if ($scope.searchResults[count].spectrumID != 0 || $scope.searchResults[count].fileName.trim() != '') {
                    return true;
                }

            }
        }

        return false;
    }

    $scope.SetWorkSpaceSaveBuuton = function () {

        if ($scope.AllowWorkSpaceSave()) {
            angular.element(document.getElementsByClassName("save-graph-icon")).removeClass("disabled").attr("disabled", false);
        }
        else {
            angular.element(document.getElementsByClassName("save-graph-icon")).addClass("disabled").attr("disabled", true);
        }
    }

    $scope.SetWorkSpaceSaveBuuton();

    $scope.ShowDataSetSearchDetailsForSave = function (searchResult) {

        plotgraphservice.setSearchTerm($scope, searchResult.spectrumID, searchResult.displayID, searchResult.technique)
    }

    $rootScope.urlworkspaceid = null;
}]);

app.service('plotgraphservice', ['$http', 'plotDataService', 'progressBarService', '$compile', '$rootScope', '$window', '$location', function ($http, plotDataService, progressBarService, $compile, $rootScope, $window, $location) {

    this.renderChart2 = function ($scope, $location, chartId, legendDivId, fetchDataFromDB) {
        var chartData = [];
        progressBarService.showProgressBar();
        // Get PeakInfo Data  from API call
        var datapoint1Peakinfo = null;
        var datapoint1 = null;
        var showAstrikonLegend = 'none';
        var showPeakLabel = 'hide-show-label bg-color-1';
        var showPeakLabelText = 'graph-text';

        var graphConfig = [];
        var dataPoints = null;
        var dataPeakInfo = null;

        var graphColour = null;
        var graphTitle = null;
        var configData = [];

        var intensityFlag = 'intensity';
        var intensityFlag1 = 'intensity-1';

        var isSuccess = true;


        if (fetchDataFromDB) {
            $scope.searchResults = [];

            $.ajax({
                url: $scope.serviceBase + 'PlotGraph',
                async: false,
                type: "GET",
                dataType: "json",
                data: {
                    dataSetIds: $scope.spectrumIdList.toString(), startVal: $scope.startendValues[0], endVal: $scope.startendValues[1], sessionID: $scope.SessionUploadID, fileList: $scope.fileDataSet.toString(), WorkspaceID: $rootScope.workspaceID
                }
            }).success(function (data, jqXHR) {
                if (jqXHR == "nocontent") {
                    $scope.searchResultMsg = "No data found.";
                    isSuccess = false;
                }
                else {
                    // Set Mobile Size
                    $scope.premiumType = data.premiumType;
                    setLocalValue("premiumType", $scope.premiumType);
                    angular.forEach(data.graphPlotDataList, function (value, key) {
                        value.mobiledevice = $scope.mobileSize;
                        value.device = $scope.device;
                        value.spectrumID = value.spectrumID == 0 && value.objectContentType == "kratos" ? value.displayID : value.spectrumID; // for kratos data with 0 spectrum id
                    });

                    $scope.searchResults = data.graphPlotDataList;

                    $scope.searchResultsBackUp = angular.copy(data.graphPlotDataList);
                }
            }).error(function (request, status, error) {
                if (error == "Not Found") {
                    $scope.searchResultMsg = "No data found.";
                }
                else if (error == "Service Unavailable") {
                    progressBarService.hideProgressBar();
                    if ($rootScope.globalConfig.errorPage == undefined || $rootScope.globalConfig.errorPage == null || $rootScope.globalConfig.errorPage == '') {
                        $location.path("/error");
                    }
                    else {
                        $window.location.href = '../app/modules/error/' + $rootScope.globalConfig.errorPage;
                    }
                    return false;
                }
                else if (error == "Internal Server Error") {
                    progressBarService.hideProgressBar();
                    if ($rootScope.globalConfig.errorPage == undefined || $rootScope.globalConfig.errorPage == null || $rootScope.globalConfig.errorPage == '') {
                        $location.path("/error");
                    }
                    else {
                        $window.location.href = '../app/modules/error/' + $rootScope.globalConfig.errorPage;
                    }
                    return false;
                }

                //console.log($scope.searchResultMsg);
                isSuccess = false;
            });
        }

        if (!isSuccess) {
            alert($scope.searchResultMsg);
            $location.path('/search');
            progressBarService.hideProgressBar();
            return false;
        }

        //Set flag for figures
        $(".graph-figures input[type=radio]").each(function () {
            if ($(this).prop("checked") == true) {
                getFigure = $(this).attr("graph-figures");
            }
        });

        generateChartData();

        function generateChartData() {
            $scope.isDownloadNotRistricted = true;
            //Clean all custom legends
            $("#customLegends").children().remove();
            for (var count = 0; count < $scope.searchResults.length; count++) {

                var isValidDataset = $scope.searchResults[count].objectContentType.toLowerCase() == 'nist' && $scope.premiumType == 0 ? false : $scope.checkPremiumType($scope.searchResults[count].spectrumID);

                if ($scope.searchResults[count].visible === true) {
                    $scope.searchResults[count].visible = isValidDataset && $scope.searchResults[count].objectStatusType == 'active';
                    $scope.searchResults[count].visible = $scope.searchResults[count].visible ? $scope.searchResults[count].isValidFigureData : $scope.searchResults[count].visible;
                }
                $scope.searchResults[count].isPremium = isValidDataset;

                if ($scope.isDownloadNotRistricted) {
                    $scope.isDownloadNotRistricted = isValidDataset;
                }

                if ($scope.searchResults[count].objectContentType != "kratos" || ($scope.searchResults[count].objectContentType == "kratos" && $scope.isKratosData == 1)) {
                    if (($scope.searchResults[count].technique.toLowerCase() == getFigure.toLowerCase() || ($scope.searchResults[count].technique.toLowerCase() == "ups" && getFigure.toLowerCase() == "xps") || $scope.searchResults[count].technique.toLowerCase() == "unpublished") && $scope.searchResults[count].visible == true) {
                        var datasetarrayDynamic = null;
                        var peakinfo1 = null;
                        showAstrikonLegend = 'none';
                        showPeakLabel = 'hide-show-label bg-color-1';
                        showPeakLabelText = 'graph-text';


                        datasetarrayDynamic = $scope.searchResults[count].datapoint.data;
                        peakinfo1 = $scope.searchResults[count].peakInfo;

                        graphColour = $scope.searchResults[count].graphColour;
                        graphTitle = $scope.searchResults[count].graphTitle;

                        for (var i = 0; i < datasetarrayDynamic.length; i++) {
                            var xVal = parseFloat(datasetarrayDynamic[i][0]).toFixed(3);
                            var yVal = parseFloat(datasetarrayDynamic[i][1]).toFixed(3);

                            // if (flag == 0) {
                            var obj = {
                            };
                            obj['eV'] = xVal;
                            obj[intensityFlag] = yVal;
                            //obj['peakEnergy'] = '';
                            chartData.push(obj);
                            //}
                        }
                        for (var i = 0; i < peakinfo1.length; i++) {
                            var xVal = parseFloat(peakinfo1[i].xval).toFixed(3);
                            var yVal = parseFloat(peakinfo1[i].yval).toFixed(3);
                            var label = peakinfo1[i].lbltext;
                            var flag = 0;


                            // if (flag == 0) {
                            var obj = {
                            };
                            obj['eV'] = xVal;
                            obj[intensityFlag1] = yVal;
                            obj['peakEnergy'] = "<b>Peak Energy</b> : " + parseFloat(peakinfo1[i].peakEnergy).toFixed(3);
                            obj["label"] = label;
                            chartData.push(obj);
                            // }
                        }

                        // ShowHide Peak Labels
                        var peakLabel = "[[label]]";
                        //var peakLabel = "";

                        if ($scope.searchResults[count].showPeakLabel == false) {
                            peakLabel = "";
                        }

                        configData.push({
                            "gid": "AmGraph-" + (count + 1),
                            "valueAxis": "v" + (count + 1),
                            "title": graphTitle,
                            "type": "line",
                            "lineAlpha": 1,
                            "xField": "eV",
                            "yField": intensityFlag,
                            "lineColor": graphColour,
                            //"labelText": "[[label]]",
                            "color": graphColour,
                            "valueField": "label",
                            "balloonText": "<div style='margin:1px; font-size:10px;'><div style='font-size:11px;'>[[eV]] , [[" + intensityFlag + "]]</div><div><b>[[peakEnergy]] </div></div>",
                            "bullet": "round",
                            "bulletAlpha": 0,
                            "bulletSize": 0
                        }, {
                            "gid": "AmGraph-1-" + (count + 1),
                            "valueAxis": "v1-" + (count + 1),
                            "title": graphTitle,
                            "type": "line",
                            "lineAlpha": 0,
                            "xField": "eV",
                            "yField": intensityFlag1,
                            "lineColor": graphColour,
                            "labelText": peakLabel,
                            "color": graphColour,
                            "valueField": "label",
                            "balloonText": "<div style='margin:1px; font-size:10px;'><div>[[peakEnergy]] </div></div>",
                            "bullet": "round",
                            "bulletAlpha": 0,
                            "bulletSize": 0,
                            //"bulletBorderAlpha": 1,
                            //"bulletBorderColor": "#FF9E01",
                            //"hideBulletsCount": 50,
                        });

                        intensityFlag = 'intensity' + (count + 1);
                        intensityFlag1 = 'intensity1' + (count + 1);

                        if ($scope.searchResults[count].yOffset != '') {
                            showAstrikonLegend = 'inline-block';
                        }

                        //Legend Peak Labels
                        if ($scope.searchResults[count].showPeakLabel == false) {
                            showPeakLabel = 'hide-show-label bg-color-1 hidden-labels';
                            showPeakLabelText = 'graph-text disabled-text';
                        }

                        //function to generate custom legends
                        customLegend(count, graphColour, graphTitle, $scope.searchResults[count].displayID, showAstrikonLegend, showPeakLabel, showPeakLabelText);

                    } else {
                        var obj = {
                        };
                        obj['eV'] = 0;
                        obj[intensityFlag] = 0;
                        chartData.push(obj);

                        configData.push({
                            "gid": "AmGraph-" + (0),
                            "valueAxis": "v" + (0),
                            "title": graphTitle,
                            "type": "line",
                            "lineAlpha": 1,
                            "xField": "eV",
                            "yField": intensityFlag,
                            "lineColor": graphColour,
                            "color": graphColour,
                            "valueField": "visits",
                            "balloonText": "<div style='margin:1px; font-size:10px;'><div style='font-size:11px;'>[[eV]] , [[" + intensityFlag + "]]</div><div><b>[[peakEnergy]] </div></div>",
                            "bullet": "round",
                            "bulletAlpha": 0,
                            "bulletSize": 0
                        }, {
                            "gid": "AmGraph-1-" + (0),
                            "valueAxis": "v1-" + (0),
                            "title": graphTitle,
                            "type": "line",
                            "lineAlpha": 0,
                            "xField": "eV",
                            "yField": intensityFlag1,
                            "lineColor": graphColour,
                            "labelText": peakLabel,
                            "color": graphColour,
                            "valueField": "label",
                            "balloonText": "<div style='margin:1px; font-size:10px;'><div>[[peakEnergy]] </div></div>",
                            "bullet": "round",
                            "bulletAlpha": 0,
                            "bulletSize": 0
                        });
                    }
                } else {
                    var obj = {
                    };
                    obj['eV'] = 0;
                    obj[intensityFlag] = 0;
                    chartData.push(obj);

                    configData.push({
                        "gid": "AmGraph-" + (0),
                        "valueAxis": "v" + (0),
                        "title": graphTitle,
                        "type": "line",
                        "lineAlpha": 1,
                        "xField": "eV",
                        "yField": intensityFlag,
                        "lineColor": graphColour,
                        "color": graphColour,
                        "valueField": "visits",
                        "balloonText": "<div style='margin:1px; font-size:10px;'><div style='font-size:11px;'>[[eV]] , [[" + intensityFlag + "]]</div><div><b>[[peakEnergy]] </div></div>",
                        "bullet": "round",
                        "bulletAlpha": 0,
                        "bulletSize": 0
                    }, {
                        "gid": "AmGraph-1-" + (0),
                        "valueAxis": "v1-" + (0),
                        "title": graphTitle,
                        "type": "line",
                        "lineAlpha": 0,
                        "xField": "eV",
                        "yField": intensityFlag1,
                        "lineColor": graphColour,
                        "labelText": peakLabel,
                        "color": graphColour,
                        "valueField": "label",
                        "balloonText": "<div style='margin:1px; font-size:10px;'><div>[[peakEnergy]] </div></div>",
                        "bullet": "round",
                        "bulletAlpha": 0,
                        "bulletSize": 0
                    });
                }
            }

            if ($scope.searchResults.length == 0) {
                var obj = {
                };
                obj['eV'] = 0;
                obj[intensityFlag] = 0;
                chartData.push(obj);

                configData.push({
                    "gid": "AmGraph-" + (0),
                    "valueAxis": "v" + (0),
                    "title": graphTitle,
                    "type": "line",
                    "lineAlpha": 1,
                    "xField": "eV",
                    "yField": intensityFlag,
                    "lineColor": graphColour,
                    "color": graphColour,
                    "valueField": "label",
                    "balloonText": "<div style='margin:1px; font-size:10px;'><div style='font-size:11px;'>[[eV]] , [[" + intensityFlag + "]]</div><div><b>[[peakEnergy]] </div></div>",
                    "bullet": "round",
                    "bulletAlpha": 0,
                    "bulletSize": 0
                }, {
                    "gid": "AmGraph-1-" + (0),
                    "valueAxis": "v1-" + (0),
                    "title": graphTitle,
                    "type": "line",
                    "lineAlpha": 0,
                    "xField": "eV",
                    "yField": intensityFlag1,
                    "lineColor": graphColour,
                    "labelText": peakLabel,
                    "color": graphColour,
                    "valueField": "label",
                    "balloonText": "<div style='margin:1px; font-size:10px;'><div>[[peakEnergy]] </div></div>",
                    "bullet": "round",
                    "bulletAlpha": 0,
                    "bulletSize": 0
                });
            }
        }

        if (getFigure == "XPS") {
            st = true;
        } else {
            st = false;
        }
        $scope.isShowAllPeakLabels = getFigure.toLowerCase() == "uv-vis" ? false : true;
        var bottomTitle = getFigure.toLowerCase() == "uv-vis" ? "Wavelength (nm)" : "Energy (eV)";
        var leftTitle = getFigure.toLowerCase() == "uv-vis" ? "Logarithm Epsilon (cm" : "Intensity (Counts/s)";

        chart = AmCharts.makeChart(chartId, {
            "type": "xy",
            "zoomOutButtonAlpha": 1,
            "export": {
                "enabled": $scope.isDownloadNotRistricted,
                "menu": [{
                    "class": "export-main",
                    "menu": [{
                        "label": "Download as ...",
                        "menu": ["PNG", "JPG", "CSV", "PDF"]
                    }, {
                        label: "Save as ...",
                        menu: ["CSV", "XLSX", "JSON"]
                    }, {
                        format: "PRINT",
                        label: "Print Graph"
                    }, {
                        format: "PRINT",
                        label: "Print Page"
                    }]
                }]
            },
            "zoomLatitude": 0,
            "zoomLongitude": 0,
            "mouseWheelZoomEnabled": true,

            //"legend": {
            //    //"useGraphSettings": false,
            //    //"align": "center",
            //    //"markerSize": 16,
            //    //"markerType": "square",
            //    //"divId": legendDivId,
            //    //"clickMarker": handleLegendClick,
            //    //"clickLabel": handleLegendClick
            //    "enabled": false
            //},

            "graphs": configData,

            "valueAxes": [
            {
                "title": bottomTitle,
                "position": "bottom",
                "reversed": st,
            },
            {
                "title": leftTitle,
                "position": "left"
            }
            ],

            "chartCursor": {
                "valueLineBalloonEnabled": false,
                //"cursorAlpha": 0,
                "cursorColor": "#258cbb",
                //"valueLineAlpha": 0,
                //"valueZoomable": true,
                "cursorPosition": "mouse"
            },

            "chartScrollbar": {
                "updateOnReleaseOnly": true
            },

            "balloon": {
                "fixedPosition": false,
                "offsetY": 20
            },

            "dataProvider": chartData

        });

        function handleLegendClick(graph) {
            var chartVar = graph.chart;
            for (var i = 0; i < chartVar.graphs.length; i++) {
                if (graph.id == chartVar.graphs[i].id) {
                    var graphRow = $("#graph-row-" + i);

                    if ($(graphRow).children().find(".show-hide-graph").hasClass("fa-eye")) {
                        $(graphRow).find(".show-hide-graph").toggleClass("fa-eye-slash fa-eye");
                        $(graphRow).find(".show-hide-graph").attr("title", "Show graph");
                        chartVar.hideGraph(chartVar.graphs[i]);
                    } else {
                        $(graphRow).find(".show-hide-graph").toggleClass("fa-eye-slash fa-eye");
                        $(graphRow).find(".show-hide-graph").attr("title", "Hide graph");
                        chartVar.showGraph(chartVar.graphs[i]);
                    }

                    //Hide amcharts text on graph
                    $("#chartdiv").find(".amcharts-chart-div a").hide();
                }
            }

            // return false so that default action is canceled
            return false;
        }

        function customLegend(count, graphColour, graphTitle, spectrumID, showAstrikonLegend, showPeakLabel, showPeakLabelText) {
            var legend = '<div class="legend">' +
                '<span class="' + showPeakLabel + '" graph-no="' + (count + 1) + '" graph-id="AmGraph-1-' + (count + 1) + '" ng-click="VisibleSelectedPeakLabel(\'' + spectrumID + '\',$event)" style="background-color: ' + graphColour + ';" title="Hide labels"></span>' +
                '<span class="' + showPeakLabelText + '">' + graphTitle + '<span class="glyphicon glyphicon-asterisk offset-asterisk bg-color-1" spectrum-id="' + spectrumID + '" style="color: ' + graphColour + ';display: ' + showAstrikonLegend + ';" toggle="row-1"></span></span>' +
            '</div>';
            var compiledHtml = $compile(legend)($scope);
            angular.element(document.getElementById('customLegends')).append(compiledHtml);
        }

        function handleClick(event) {
            console.log(event);
        }

        chart.handleResize();
        chart.write("chartdiv");

        if (getFigure.toLowerCase() == "uv-vis") {
            var tspanElements = [];
            tspanElements = document.getElementsByTagName("tspan");
            if (tspanElements.length > 0)
                angular.forEach(tspanElements, function (value, key) {
                    var textContent = value.textContent;
                    if (textContent != undefined && textContent.indexOf("Logarithm Epsilon") > -1) {
                        var firstTspan = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
                        firstTspan.setAttributeNS(null, "dy", "-5");
                        var firstTextnode = document.createTextNode("2");
                        firstTspan.appendChild(firstTextnode);
                        var secondTspan = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
                        secondTspan.setAttributeNS(null, "dy", "5");
                        var secondTextnode = document.createTextNode("/mol)");
                        secondTspan.appendChild(secondTextnode);
                        value.appendChild(firstTspan);
                        value.appendChild(secondTspan);
                    }
                });
        }

        hideAllPeakLabel();
        function hideAllPeakLabel() {
            var getTotalLength = angular.element(document.getElementById('customLegends')).children(":visible").length;
            var getHiddenLabelsLength = angular.element(document.getElementById('customLegends')).find(".hidden-labels").length;

            if (getTotalLength == getHiddenLabelsLength) {
                if (getTotalLength == 0) {
                    angular.element(document.getElementsByClassName("show-all-peak-labels")).prop("checked", false);
                    angular.element(document.getElementsByClassName("show-all-peak-labels")).attr("title", "Check to show all labels");
                    angular.element(document.getElementsByClassName("show-all-peak-labels")).attr("disabled", "disabled");
                }
                else {
                    angular.element(document.getElementsByClassName("show-all-peak-labels")).prop("checked", false);
                    angular.element(document.getElementsByClassName("show-all-peak-labels")).attr("title", "Check to show all labels");
                    angular.element(document.getElementsByClassName("show-all-peak-labels")).removeAttr("disabled");
                }
            }
            else if (getHiddenLabelsLength == 0) {
                angular.element(document.getElementsByClassName("show-all-peak-labels")).removeAttr("disabled");
                angular.element(document.getElementsByClassName("show-all-peak-labels")).prop("checked", true);
                angular.element(document.getElementsByClassName("show-all-peak-labels")).attr("title", "Uncheck to hide all labels");
            }
        }

        //angular.element(document.getElementsByClassName("page-spinner")).hide();
    };

    this.renderZoomableChart = function ($scope, $location, chartId, legendDivId, fetchDataFromDB) {
        var chartData = [];
        progressBarService.showProgressBar();
        // Get PeakInfo Data  from API call
        var datapoint1Peakinfo = null;
        var datapoint1 = null;
        var showAstrikonLegend = 'none';
        var showPeakLabel = 'hide-show-label bg-color-1';
        var showPeakLabelText = 'graph-text';

        var graphConfig = [];
        var dataPoints = null;
        var dataPeakInfo = null;

        var graphColour = null;
        var graphTitle = null;
        var configData = [];

        var intensityFlag = 'intensity';
        var intensityFlag1 = 'intensity-1';

        generateChartData();

        function generateChartData() {
            $scope.isDownloadNotRistricted = true;
            //Clean all custom legends
            $("#customLegends").children().remove();
            for (var count = 0; count < $scope.searchResults.length; count++) {
                var isValidDataset = $scope.searchResults[count].objectContentType.toLowerCase() == 'nist' && $scope.premiumType == 0 ? false : $scope.checkPremiumType($scope.searchResults[count].spectrumID);
                if ($scope.searchResults[count].visible === true) {
                    $scope.searchResults[count].visible = isValidDataset && $scope.searchResults[count].objectStatusType == 'active';
                }
                $scope.searchResults[count].isPremium = isValidDataset;

                if (($scope.searchResults[count].technique.toLowerCase() == getFigure.toLowerCase() || ($scope.searchResults[count].technique.toLowerCase() == "ups" && getFigure.toLowerCase() == "xps") || $scope.searchResults[count].technique.toLowerCase() == "unpublished") && $scope.searchResults[count].visible == true) {
                    var datasetarrayDynamic = null;
                    var peakinfo1 = null;
                    showAstrikonLegend = 'none';
                    showPeakLabel = 'hide-show-label bg-color-1';
                    showPeakLabelText = 'graph-text';

                    if ($scope.isDownloadNotRistricted) {
                        $scope.isDownloadNotRistricted = isValidDataset;
                    }

                    datasetarrayDynamic = $scope.searchResults[count].datapoint.data;
                    peakinfo1 = $scope.searchResults[count].peakInfo;

                    graphColour = $scope.searchResults[count].graphColour;
                    graphTitle = $scope.searchResults[count].graphTitle;

                    for (var i = 0; i < datasetarrayDynamic.length; i++) {
                        var xVal = parseFloat(datasetarrayDynamic[i][0]).toFixed(3);
                        var yVal = parseFloat(datasetarrayDynamic[i][1]).toFixed(3);

                        // if (flag == 0) {
                        var obj = {
                        };
                        obj['eV'] = xVal;
                        obj[intensityFlag] = yVal;
                        //obj['peakEnergy'] = '';
                        chartData.push(obj);
                        //}
                    }
                    for (var i = 0; i < peakinfo1.length; i++) {
                        var xVal = parseFloat(peakinfo1[i].xval).toFixed(3);
                        var yVal = parseFloat(peakinfo1[i].yval).toFixed(3);
                        var label = peakinfo1[i].lbltext;
                        var flag = 0;


                        // if (flag == 0) {
                        var obj = {
                        };
                        obj['eV'] = xVal;
                        obj[intensityFlag1] = yVal;
                        obj['peakEnergy'] = "<b>Peak Energy</b> : " + parseFloat(peakinfo1[i].peakEnergy).toFixed(3);
                        obj["label"] = label;
                        chartData.push(obj);
                        // }
                    }

                    // ShowHide Peak Labels
                    var peakLabel = "[[label]]";
                    //var peakLabel = "";

                    if ($scope.searchResults[count].showPeakLabel == false) {
                        peakLabel = "";
                    }

                    configData.push({
                        "gid": "AmGraph-" + (count + 1),
                        "valueAxis": "v" + (count + 1),
                        "title": graphTitle,
                        "type": "line",
                        "lineAlpha": 1,
                        "xField": "eV",
                        "yField": intensityFlag,
                        "lineColor": graphColour,
                        //"labelText": "[[label]]",
                        "color": graphColour,
                        "valueField": "label",
                        "balloonText": "<div style='margin:1px; font-size:10px;'><div style='font-size:11px;'>[[eV]] , [[" + intensityFlag + "]]</div><div><b>[[peakEnergy]] </div></div>",
                        "bullet": "round",
                        "bulletAlpha": 0,
                        "bulletSize": 0
                    }, {
                        "gid": "AmGraph-1-" + (count + 1),
                        "valueAxis": "v1-" + (count + 1),
                        "title": graphTitle,
                        "type": "line",
                        "lineAlpha": 0,
                        "xField": "eV",
                        "yField": intensityFlag1,
                        "lineColor": graphColour,
                        "labelText": peakLabel,
                        "color": graphColour,
                        "valueField": "label",
                        "balloonText": "<div style='margin:1px; font-size:10px;'><div>[[peakEnergy]] </div></div>",
                        "bullet": "round",
                        "bulletAlpha": 0,
                        "bulletSize": 0,
                        //"bulletBorderAlpha": 1,
                        //"bulletBorderColor": "#FF9E01",
                        //"hideBulletsCount": 50,
                    });

                    intensityFlag = 'intensity' + (count + 1);
                    intensityFlag1 = 'intensity1' + (count + 1);

                    if ($scope.searchResults[count].yOffset != '') {
                        showAstrikonLegend = 'inline-block';
                    }

                    //Legend Peak Labels
                    if ($scope.searchResults[count].showPeakLabel == false) {
                        showPeakLabel = 'hide-show-label bg-color-1 hidden-labels';
                        showPeakLabelText = 'graph-text disabled-text';
                    }

                    //function to generate custom legends
                    customLegend(count, graphColour, graphTitle, $scope.searchResults[count].displayID, showAstrikonLegend, showPeakLabel, showPeakLabelText);

                }
            }

            chart.ignoreZoomed = true;
            chart.dataProvider = chartData;
            chart.validateData();

            if (getFigure.toLowerCase() == "uv-vis") {
                var tspanElements = [];
                tspanElements = document.getElementsByTagName("tspan");
                if (tspanElements.length > 0)
                    angular.forEach(tspanElements, function (value, key) {
                        var textContent = value.textContent;
                        if (textContent != undefined && textContent.indexOf("Logarithm Epsilon") > -1) {
                            var firstTspan = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
                            firstTspan.setAttributeNS(null, "dy", "-5");
                            var firstTextnode = document.createTextNode("2");
                            firstTspan.appendChild(firstTextnode);
                            var secondTspan = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
                            secondTspan.setAttributeNS(null, "dy", "5");
                            var secondTextnode = document.createTextNode("/mol)");
                            secondTspan.appendChild(secondTextnode);
                            value.appendChild(firstTspan);
                            value.appendChild(secondTspan);
                        }
                    });
            }
        }

        function customLegend(count, graphColour, graphTitle, spectrumID, showAstrikonLegend, showPeakLabel, showPeakLabelText) {
            var legend = '<div class="legend">' +
                '<span class="' + showPeakLabel + '" graph-no="' + (count + 1) + '" graph-id="AmGraph-1-' + (count + 1) + '" ng-click="VisibleSelectedPeakLabel(\'' + spectrumID + '\',$event)" style="background-color: ' + graphColour + ';" title="Hide labels"></span>' +
                '<span class="' + showPeakLabelText + '">' + graphTitle + '<span class="glyphicon glyphicon-asterisk offset-asterisk bg-color-1" spectrum-id="' + spectrumID + '" style="color: ' + graphColour + ';display: ' + showAstrikonLegend + ';" toggle="row-1"></span></span>' +
            '</div>';
            var compiledHtml = $compile(legend)($scope);
            angular.element(document.getElementById('customLegends')).append(compiledHtml);
        }


    };


    function GetCheckedGraph(graphNo) {
        //Set flag for figures
        //var count = 0;
        var returnVal = false;
        var checkBoxes = $(".show-hide-graph")

        for (var i = 0; i < checkBoxes.length; i++) {
            if (checkBoxes[i].checked == true && i == graphNo) {
                returnVal = true;
                break;
            }
        }

        return returnVal;
    }

    function hideAllPeakLabel() {
        var getTotalLength = angular.element(document.getElementById('customLegends')).children(":visible").length
        var getHiddenLabelsLength = angular.element(document.getElementById('customLegends')).find(".hidden-labels").length;

        if (getTotalLength == getHiddenLabelsLength) {
            if (getTotalLength == 0) {
                angular.element(document.getElementsByClassName("show-all-peak-labels")).prop("checked", false);
                angular.element(document.getElementsByClassName("show-all-peak-labels")).attr("title", "Check to show all labels");
                angular.element(document.getElementsByClassName("show-all-peak-labels")).attr("disabled", "disabled");
            }
            else {
                angular.element(document.getElementsByClassName("show-all-peak-labels")).prop("checked", false);
                angular.element(document.getElementsByClassName("show-all-peak-labels")).attr("title", "Check to show all labels");
                angular.element(document.getElementsByClassName("show-all-peak-labels")).removeAttr("disabled");
            }
        }
        else if (getHiddenLabelsLength == 0) {
            angular.element(document.getElementsByClassName("show-all-peak-labels")).removeAttr("disabled");
            angular.element(document.getElementsByClassName("show-all-peak-labels")).prop("checked", true);
            angular.element(document.getElementsByClassName("show-all-peak-labels")).attr("title", "Uncheck to hide all labels");
        }
    }


    //offset input change
    $(".swipe-wrap").on('keyup', ".offset-input", function (e) {
        //validate value
        var getVal = $(this).val();
        if (getVal.substr(0, 1) == "-") {
            $(this).attr("maxlength", "7");
        } else {
            $(this).attr("maxlength", "6");
        }
        if ((!isNaN(getVal) && getVal > -1000000 && getVal < 1000000) || (getVal == "-")) {
            $(this).removeClass("border-red");

            //copy the value to print table value
            var getRow = $(this).closest("tr").attr("row");
            var getVal = $(this).val();
            $(".print-visible").find("." + getRow).find(".offset-input").attr("value", getVal);

        } else {
            $(this).addClass("border-red");
            return false;
        }
    });

    this.getSpectraFiguredetails = function ($scope, spectrunID) {
        $.ajax({
            url: $scope.serviceBase + 'Instrument',
            async: true,
            type: "GET",
            dataType: "json",
            data: {
                'spectrumId': spectrunID
            }
        }).success(function (data) {

            $scope.spectrumDetails = data;
            $scope.spectrumDetails.figureNumber = spectrunID.toString().replace($scope.spectrumDetails.accessionNo, $scope.spectrumDetails.accessionNo + '-');
            $scope.$apply();
            $('#details').modal('show');


        }).error(function (request, status, error) {
            //alert();
        });
    };

    this.getSpectraFiguredetailsByFileName = function ($scope, fileName) {

        $.ajax({
            url: $scope.serviceBase + 'InstrumentByFileName',
            async: true,
            type: "GET",
            dataType: "json",
            data: {
                'fileName': fileName
            }
        }).success(function (data) {

            $scope.spectrumDetails = data;
            $scope.spectrumDetails.figureNumber = "";
            $scope.$apply();
            $('#details').modal('show');


        }).error(function (request, status, error) {
            //alert();
        });
    };


    this.deleteUnpublishedDataSets = function ($scope, uniqueID, filename, deleteAllRows) {
        return $http({
            method: "GET",
            url: $scope.serviceBase + "deleteFiles",
            params: {
                'uniqueID': uniqueID, 'sessionID': $scope.SessionUploadID, 'deleteAllRows': deleteAllRows
            },
            headers: {
                'Content-Type': 'application/json'
            }
        }).success(function (data, status) {
            if (status != "204") {
                if (!deleteAllRows) {
                    plotDataService.removeUnPublishedDataSet(filename);
                    --$scope.unPublishedIDs;
                    if ($scope.UnPublishedDataSetCount <= 0) {
                        $(".clear-all-datasets").show();
                    }
                    $scope.$apply();
                }
                else {
                    plotDataService.clearUnPublishedDataSet();
                    $scope.unPublishedIDs = 0;
                    $scope.$apply();
                }
            }
        }).error(function (data, status) {
            if (status == "204") {
            }
        });
    };

    this.getCitedetails = function ($scope, spectrunID) {
        $.ajax({
            url: $scope.serviceBase + 'GetCiteDetails',
            async: true,
            type: "GET",
            dataType: "json",
            data: {
                'spectrumId': spectrunID
            }
        }).success(function (data, status) {
            if (status != "204") {
                $scope.CiteDetails = data;

                $scope.$apply();
                $('#cite').modal('show');
            }
        }).error(function (request, status, error) {
            //alert();
        });
    };

    this.getCitedetailsByFile = function ($scope, fileName) {

        $.ajax({
            url: $scope.serviceBase + 'GetCiteDetailsByFileName',
            async: true,
            type: "GET",
            dataType: "json",
            data: {
                'fileName': fileName
            }
        }).success(function (data, status) {
            if (status != "204") {
                $scope.CiteDetails = data;

                $scope.$apply();
                $('#cite').modal('show');
            }
        }).error(function (request, status, error) {
            //alert();
        });
    };

    this.setSearchTerm = function ($scope, spectrunID, fileName, technique) {

        $scope.dataSetSearchDetailsToSave = null;
        var searchString = plotDataService.getSearchString();

        $('#searchTermsModal').modal('show');

        if (searchString != null) {
            for (var i = 0; i < searchString.length; i++) {
                var isShow = technique.toLowerCase() == 'uv-vis' ? searchString[i].FileName == fileName : searchString[i].id == spectrunID;
                if (isShow) {

                    var temp = searchString[i].Searchstring.split("|");
                    if ($scope.flagUV) {
                        $scope.dataSetSearchDetailsToSave = {
                            spectrumID: spectrunID,
                            keyWord: temp[0].split(":")[1],
                            chemicalName: temp[1].split(":")[1],
                            casRegistryNumber: temp[2].split(":")[1],
                            technique: temp[3].split(":")[1],
                            authorLastName: temp[4].split(":")[1],
                            publicationYear: temp[5].split(":")[1],
                            sourceTitle: temp[6].split(":")[1],
                        };
                    } else {
                        $scope.dataSetSearchDetailsToSave = {
                            spectrumID: spectrunID,
                            keyWord: temp[0].split(":")[1],
                            chemicalName: temp[1].split(":")[1],
                            element: temp[2].split(":")[1],
                            hostMaterial: temp[3].split(":")[1],
                            transition: temp[4].split(":")[1],
                            technique: temp[5].split(":")[1].replace("UNSPECIFIED", "Unspecified"),
                            accession: temp[6].split(":")[1],
                            authorLastName: temp[7].split(":")[1],
                            spectralRegion: temp[8].split(":")[1].replace("UNSPECIFIED", "Unspecified"),
                            startValue: temp[9].split(":")[1],
                            endValue: temp[10].split(":")[1],
                            fromYear: temp[11].split(":")[1],
                            todate: temp[12].split(":")[1],
                            doi: temp[13].split(":")[1]
                        };
                    }

                    break;
                }
            }
        }
    };

    this.GetWorkSpaceDetailsById = function ($scope, workspaceId, decryptedWorkareaid) {
        $.ajax({
            url: $scope.serviceBase + 'GetWorkSpaceByID',
            async: false,
            type: "GET",
            dataType: "json",
            data: {
                dataSetIds: workspaceId, DecryptedWorkareaid: decryptedWorkareaid
            }
        }).success(function (data) {
            var workAreaId, workAreaName, workspaceOwnerId;

            for (var key in data) {
                if (data[key].workAreaID != undefined) {
                    if (data[key].objectDataSetName != "") {
                        //objectWorkSpaceId = data[key].workAreaID;
                        plotDataService.addFileList(data[key].objectID);
                    }
                    //} else {
                    workAreaId = data[key].workAreaID;
                    workspaceOwnerId = data[key].eSpectraPersonID;
                    //}
                    workAreaName = data[key].areaName;
                    plotDataService.addSetdata(data[key].workAreaID, data[key].spectrumID > 0 ? data[key].objectID : 0, data[key].spectrumID, data[key].technique, data[key].chemicalName, data[key].hostMaterial, data[key].spectralRegion, data[key].pubDate, data[key].dOI, data[key].objectDataSetName != "" ? data[key].objectID : "", data[key].isCurated, true);
                    if (data[key].spectrumID > 0) {
                        plotDataService.addSpectrumId(data[key].objectID);
                    }
                    plotDataService.addChemicalname(data[key].chemicalName);
                    plotDataService.addSearchString(data[key].searchStringList, data[key].spectrumID > 0 ? data[key].objectID : 0, data[key].spectrumID, workAreaId, data[key].objectDataSetName != "" ? data[key].objectID : "", true);
                    plotDataService.setTechnique(data[key].objectID, data[key].technique, true);
                }
            }

            $rootScope.SelectedWorkArea = {
                id: workAreaId, name: workAreaName, ownerId: workspaceOwnerId
            };

        }).error(function (request, status, error) {
            if (error == "Not Found") {
                $scope.searchResultMsg = "No data found.";
            }
            else if (error == "Service Unavailable") {
                if ($rootScope.globalConfig.errorPage == undefined || $rootScope.globalConfig.errorPage == null || $rootScope.globalConfig.errorPage == '') {
                    $location.path("/error");
                }
                else {
                    $window.location.href = '../app/modules/error/' + $rootScope.globalConfig.errorPage;
                }
            }
            else if (error == "Internal Server Error") {
                if ($rootScope.globalConfig.errorPage == undefined || $rootScope.globalConfig.errorPage == null || $rootScope.globalConfig.errorPage == '') {
                    $location.path("/error");
                }
                else {
                    $window.location.href = '../app/modules/error/' + $rootScope.globalConfig.errorPage;
                }
            }

            console.log($scope.searchResultMsg);
        });
    };

    this.GetComparingObjectsData = function ($scope, compareData) {
        $.ajax({
            url: $scope.serviceBase + 'GetComparingObjectsData',
            async: false,
            type: "GET",
            dataType: "json",
            data: {
                DatamanagementFile: compareData
            }
        }).success(function (data) {

            for (var key in data) {

                if (data[key].objectDataSetName != "") {
                    plotDataService.addFileList(data[key].objectID);
                }

                plotDataService.addSetdata(data[key].workAreaID, data[key].spectrumID > 0 ? data[key].objectID : 0, data[key].spectrumID, data[key].technique, data[key].chemicalName, data[key].hostMaterial, data[key].spectralRegion, data[key].pubDate, data[key].dOI, data[key].objectDataSetName != "" ? data[key].objectID : "", data[key].isCurated, true);
                if (data[key].spectrumID > 0) {
                    plotDataService.addSpectrumId(data[key].objectID);
                }
                plotDataService.addChemicalname(data[key].chemicalName);
                plotDataService.addSearchString(data[key].searchStringList, data[key].spectrumID > 0 ? data[key].objectID : 0, data[key].spectrumID, data[key].workAreaID, data[key].objectDataSetName != "" ? data[key].objectID : "", true);
                plotDataService.setTechnique(data[key].objectID, data[key].technique, true);

            }
        }).error(function (request, status, error) {
            if (error == "Not Found") {
                $scope.searchResultMsg = "No data found.";
            }
            else if (error == "Service Unavailable") {
                if ($rootScope.globalConfig.errorPage == undefined || $rootScope.globalConfig.errorPage == null || $rootScope.globalConfig.errorPage == '') {
                    $location.path("/error");
                }
                else {
                    $window.location.href = '../app/modules/error/' + $rootScope.globalConfig.errorPage;
                }
            }
            else if (error == "Internal Server Error") {
                if ($rootScope.globalConfig.errorPage == undefined || $rootScope.globalConfig.errorPage == null || $rootScope.globalConfig.errorPage == '') {
                    $location.path("/error");
                }
                else {
                    $window.location.href = '../app/modules/error/' + $rootScope.globalConfig.errorPage;
                }
            }

            console.log($scope.searchResultMsg);
        });
    };

}]);

app.directive('onFinishRender', function ($timeout) {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            if (scope.$last === true) {
                $timeout(function () {
                    scope.$emit(attr.broadcasteventname ? attr.broadcasteventname : 'ngRepeatFinished');
                });
            }
        }
    }
});

app.filter('ngRepeatFinish', function ($timeout) {
    return function (data, scope) {
        var me = this;

        var flagProperty = '__finishedRendering__';
        if (!data[flagProperty]) {
            Object.defineProperty(
                data,
                flagProperty,
            {
                enumerable: false, configurable: true, writable: false, value: {}
            });
            $timeout(function () {
                delete data[flagProperty];
                scope.$emit('ngRepeatBroadcast2');
            }, 0, false);
        }

        return data;
    }
});